import React, {Component} from 'react';
import PropTypes from "prop-types";
import VideoCategoryContainer from "./VideoCategoryContainer";
import VideoListContainer from "./VideoListContainer";

class VideoArchivContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        categoryList: PropTypes.object.isRequired,
        videoList: PropTypes.object.isRequired,
    };

    static defaultProps = {
        videoSource: 'YouTube',
        prevLink: 'videoFree',
    };

    constructor(props) {

        super(props);

        this.state = {
            selectedVideoCategory: null,
        };

        this.setSelectedVideoCategory = this.setSelectedVideoCategory.bind(this);
        this.resetSelectedVideoCategory = this.resetSelectedVideoCategory.bind(this);

    }

    setSelectedVideoCategory(videoCategory) {

        this.setState({
            selectedVideoCategory: videoCategory,
        });

    }

    resetSelectedVideoCategory() {

        this.setState({
            selectedVideoCategory: null,
        });

    }

    getVideoCategoryName() {

        let categoryActive = this.props.videoSource;
        let categories = this.props.categoryList;
        if (typeof categories !== 'undefined') {
            if (typeof categories['videoCategoryList'] !== 'undefined') {
                if (typeof categories['videoCategoryList']['category-' + categoryActive] !== 'undefined') {
                    let categorysTemp = categories['videoCategoryList']['category-' + categoryActive];

                    for (let i = 0; i < categorysTemp.length; i++) {
                        if (categorysTemp[i]['categoryId'] === this.state.selectedVideoCategory) {
                            return categorysTemp[i]['categoryName'];
                        }
                    }
                }
            }
        }

        return null;

    }

    render() {

        const selectedVideoCategory = this.state.selectedVideoCategory;

        if (selectedVideoCategory) {
            return (
                <VideoListContainer {...this.props}
                                    videoSource={this.props.videoSource}
                                    activeVideoCategory={selectedVideoCategory}
                                    activeVideoCategoryName={this.getVideoCategoryName()}
                                    onClick={this.resetSelectedVideoCategory}
                />
            );
        } else {
            return (
                <VideoCategoryContainer {...this.props}
                                        videoSource={this.props.videoSource}
                                        onClick={this.setSelectedVideoCategory}
                />
            );
        }

    }

}

export default VideoArchivContainer;